'use client';

import { useEffect, useState } from 'react';
import { Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Button } from '~/components/Buttons';
import { HeadlineSubheadCta } from '~/components/HeadlineSubheadCta';
import { AcfWatch } from '~/types/graphql';
import { Container } from '../Container';

const API_KEY = 'AIzaSyBV7m4b0eDS_mgDUPA2CRBDTUHHbteNNTE';

type YoutubeVideo = {
  id?: string;
  title?: string;
  description?: string;
  thumbnails?: { default?: string }[];
  snippet?: {
    title?: string;
    thumbnails?: { high?: { url?: string } };
    resourceId?: { videoId?: string };
  };
};

export function Watch({ watch }: AcfWatch) {
  const [videos, setVideos] = useState<YoutubeVideo[]>([]);
  // const [isMobile, setIsMobile] = useState(false);
  const { headline, subhead, youtubePlaylistId } = watch || {};

  useEffect(() => {
    if (!youtubePlaylistId) return;

    async function fetchVideos() {
      try {
        const response = await fetch(
          `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&playlistId=${youtubePlaylistId}&maxResults=10&key=${API_KEY}`,
        );
        const result = await response.json();
        if (result.items) {
          setVideos(result.items);
        }
      } catch (error) {
        console.error('Error fetching YouTube playlist videos:', error);
      }
    }

    fetchVideos();
  }, [youtubePlaylistId]);

  // useEffect(() => {
  //   const handleResize = () => setIsMobile(window.innerWidth < 992);
  //   handleResize(); // Initialize on mount
  //   window.addEventListener('resize', handleResize);
  //   return () => window.removeEventListener('resize', handleResize);
  // }, []);

  // const swiperEnabled = isMobile ? videos.length > 2 : videos.length > 3;
  // const videoSlides = Array.from({ length: 4 });

  const playlistUrl = `https://www.youtube.com/playlist?list=${youtubePlaylistId}`;

  return (
    <div className="flex flex-col self-stretch border-b border-white bg-white px-[--site-margin] py-16 text-black">
      <Container className="gap-y-9 lg:gap-y-8">
        <HeadlineSubheadCta
          headline={headline || 'Watch'}
          subhead={subhead}
          cta={{ title: 'See more', url: playlistUrl, target: '_blank' }}
          hideCtaMobile
        />

        <Swiper
          className="w-full !pb-0"
          wrapperClass="!h-auto"
          slidesPerView={1}
          spaceBetween={20}
          modules={[Pagination]}
          pagination={{ clickable: true }}
          breakpoints={{
            768: {
              slidesPerView: 'auto',
              spaceBetween: 32,
            },
            992: {
              slidesPerView: 3,
            },
          }}
        >
          {videos.map((video, index) => (
            <SwiperSlide
              className="flex max-w-[416px] flex-col items-start justify-start gap-6 gap-y-6"
              key={video.id || index}
            >
              <div className="w-full">
                <img
                  src={video?.snippet?.thumbnails?.high?.url}
                  alt={video?.snippet?.title}
                  className="w-full rounded"
                />
                <h3 className="mt-6 max-w-[90%] font-nova text-[20px] font-semibold normal-case leading-[30px] lg:mt-8">
                  {video?.snippet?.title}
                </h3>
              </div>
              {video?.snippet?.resourceId?.videoId && (
                <a
                  href={`https://www.youtube.com/watch?v=${video.snippet.resourceId.videoId}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-play-bg-2-md js-youtube-modal absolute inset-0"
                ></a>
              )}
            </SwiperSlide>
          ))}
        </Swiper>

        <Button
          className="lg:hidden"
          href={playlistUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          Watch More
        </Button>
      </Container>
    </div>
  );
}
